module.exports = __webpack_public_path__ + "static/media/3.3b7fa3d0.png";